import * as tslib_1 from "tslib";
import { AfterContentInit, EventEmitter, OnInit, QueryList } from '@angular/core';
import { TagService } from '../services/tag.service';
import { MatSnackBar } from '@angular/material';
var EditTagComponent = /** @class */ (function () {
    function EditTagComponent(_tagService, _snackBar) {
        this._tagService = _tagService;
        this._snackBar = _snackBar;
        this.change = new EventEmitter();
        this.error = new EventEmitter();
    }
    EditTagComponent.prototype.ngOnInit = function () {
    };
    EditTagComponent.prototype.ngAfterContentInit = function () {
    };
    EditTagComponent.prototype.isChecked = function (tagId) {
        var TAGS = this.business.tags || this.business.airportTags;
        for (var _i = 0, TAGS_1 = TAGS; _i < TAGS_1.length; _i++) {
            var tag = TAGS_1[_i];
            if (tag.tagId === tagId) {
                return true;
            }
        }
        return false;
    };
    EditTagComponent.prototype.checkBoxChanged = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var TAG_ID, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        TAG_ID = +event.source.id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 12, , 13]);
                        if (!event.source.checked) return [3 /*break*/, 6];
                        if (!this.business.airportId) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._tagService.postAirportTag(TAG_ID, this.business.airportId)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this._tagService.postTag(TAG_ID, this.business.id)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.change.emit();
                        return [3 /*break*/, 11];
                    case 6:
                        if (!this.business.airportId) return [3 /*break*/, 8];
                        /* the following section prevents removing the restaurant on field tag when there are local attractions that are
                        restaurants on field */
                        if (TAG_ID === 49183 && this.business.localAttractions.filter(function (a) { return a.travelType === 'Restaurant On Field'; }).length > 0) {
                            event.source.checked = true;
                            this._snackBar.open('There is a local attraction that is a restaurant on the field.  It must be removed before this tag can be removed.', 'Invalid Tag Removal', {
                                duration: 5000
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this._tagService.deleteAirportTag(TAG_ID, this.business.airportId)];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, this._tagService.deleteTag(TAG_ID, this.business.id)];
                    case 9:
                        _a.sent();
                        _a.label = 10;
                    case 10:
                        this.change.emit();
                        _a.label = 11;
                    case 11: return [3 /*break*/, 13];
                    case 12:
                        e_1 = _a.sent();
                        this.error.emit(new Error('API Call Failed'));
                        return [3 /*break*/, 13];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    return EditTagComponent;
}());
export { EditTagComponent };
